import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6276c231"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AppVersion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.env) + " - " + _toDisplayString(_ctx.version) + " - " + _toDisplayString(_ctx.commit), 1))
}